'use strict';

class overviewService {
  constructor($http) {
    this.$http = $http;
  }

  list(state, type, year) {
    return this.$http.get(`/overview/invoices/documents?state=${state}&type=${type}&year=${year}`);
  }

  get(year = null) {
    return year === null ? this.$http.get(`/overview/invoices`) : this.$http.get(`/overview/invoices?year=${year}`);
  }
}

overviewService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('overviewService', overviewService);
